export * from './addressController.service';
export * from './adminController.service';
export * from './articleController.service';
export * from './badgeController.service';
export * from './beautyProfileAdminController.service';
export * from './beautyProfileController.service';
export * from './bfluenceIntegrityController.service';
export * from './blacklistController.service';
export * from './brandController.service';
export * from './campaignController.service';
export * from './catalogController.service';
export * from './compositionController.service';
export * from './compositionDashboardController.service';
export * from './couponController.service';
export * from './couponPriceChangeController.service';
export * from './courseController.service';
export * from './customQueryController.service';
export * from './editionController.service';
export * from './emailTemplateController.service';
export * from './erpController.service';
export * from './feedbackAdminController.service';
export * from './feedbackController.service';
export * from './feedbackGroupController.service';
export * from './fileController.service';
export * from './financialAdminController.service';
export * from './financialController.service';
export * from './gcpDatabaseUserController.service';
export * from './giftCycleController.service';
export * from './influencerController.service';
export * from './integrationController.service';
export * from './integrationTokenController.service';
export * from './itOpsController.service';
export * from './kpiController.service';
export * from './liveController.service';
export * from './notificationController.service';
export * from './openController.service';
export * from './ordersController.service';
export * from './paymentController.service';
export * from './paymentRoundController.service';
export * from './personController.service';
export * from './productController.service';
export * from './resendDashboardController.service';
export * from './rewardController.service';
export * from './secretsController.service';
export * from './shippingCompanyController.service';
export * from './shippingOrderController.service';
export * from './shopOrderController.service';
export * from './subscriberController.service';
export * from './subscriptionController.service';
export * from './subscriptionTypeController.service';
export * from './subscriptionTypePriceController.service';
export * from './subscriptionTypeTaxController.service';
export * from './userController.service';
export * from './websocketController.service';
import { AddressControllerService } from './addressController.service';
import { AdminControllerService } from './adminController.service';
import { ArticleControllerService } from './articleController.service';
import { BadgeControllerService } from './badgeController.service';
import { BeautyProfileAdminControllerService } from './beautyProfileAdminController.service';
import { BeautyProfileControllerService } from './beautyProfileController.service';
import { BfluenceIntegrityControllerService } from './bfluenceIntegrityController.service';
import { BlacklistControllerService } from './blacklistController.service';
import { BrandControllerService } from './brandController.service';
import { CampaignControllerService } from './campaignController.service';
import { CatalogControllerService } from './catalogController.service';
import { CompositionControllerService } from './compositionController.service';
import { CompositionDashboardControllerService } from './compositionDashboardController.service';
import { CouponControllerService } from './couponController.service';
import { CouponPriceChangeControllerService } from './couponPriceChangeController.service';
import { CourseControllerService } from './courseController.service';
import { CustomQueryControllerService } from './customQueryController.service';
import { EditionControllerService } from './editionController.service';
import { EmailTemplateControllerService } from './emailTemplateController.service';
import { ErpControllerService } from './erpController.service';
import { FeedbackAdminControllerService } from './feedbackAdminController.service';
import { FeedbackControllerService } from './feedbackController.service';
import { FeedbackGroupControllerService } from './feedbackGroupController.service';
import { FileControllerService } from './fileController.service';
import { FinancialAdminControllerService } from './financialAdminController.service';
import { FinancialControllerService } from './financialController.service';
import { GcpDatabaseUserControllerService } from './gcpDatabaseUserController.service';
import { GiftCycleControllerService } from './giftCycleController.service';
import { InfluencerControllerService } from './influencerController.service';
import { IntegrationControllerService } from './integrationController.service';
import { IntegrationTokenControllerService } from './integrationTokenController.service';
import { ItOpsControllerService } from './itOpsController.service';
import { KpiControllerService } from './kpiController.service';
import { LiveControllerService } from './liveController.service';
import { NotificationControllerService } from './notificationController.service';
import { OpenControllerService } from './openController.service';
import { OrdersControllerService } from './ordersController.service';
import { PaymentControllerService } from './paymentController.service';
import { PaymentRoundControllerService } from './paymentRoundController.service';
import { PersonControllerService } from './personController.service';
import { ProductControllerService } from './productController.service';
import { ResendDashboardControllerService } from './resendDashboardController.service';
import { RewardControllerService } from './rewardController.service';
import { SecretsControllerService } from './secretsController.service';
import { ShippingCompanyControllerService } from './shippingCompanyController.service';
import { ShippingOrderControllerService } from './shippingOrderController.service';
import { ShopOrderControllerService } from './shopOrderController.service';
import { SubscriberControllerService } from './subscriberController.service';
import { SubscriptionControllerService } from './subscriptionController.service';
import { SubscriptionTypeControllerService } from './subscriptionTypeController.service';
import { SubscriptionTypePriceControllerService } from './subscriptionTypePriceController.service';
import { SubscriptionTypeTaxControllerService } from './subscriptionTypeTaxController.service';
import { UserControllerService } from './userController.service';
import { WebsocketControllerService } from './websocketController.service';
export const APIS = [
  AddressControllerService,
  AdminControllerService,
  ArticleControllerService,
  BadgeControllerService,
  BeautyProfileAdminControllerService,
  BeautyProfileControllerService,
  BfluenceIntegrityControllerService,
  BlacklistControllerService,
  BrandControllerService,
  CampaignControllerService,
  CatalogControllerService,
  CompositionControllerService,
  CompositionDashboardControllerService,
  CouponControllerService,
  CouponPriceChangeControllerService,
  CourseControllerService,
  CustomQueryControllerService,
  EditionControllerService,
  EmailTemplateControllerService,
  ErpControllerService,
  FeedbackAdminControllerService,
  FeedbackControllerService,
  FeedbackGroupControllerService,
  FileControllerService,
  FinancialAdminControllerService,
  FinancialControllerService,
  GcpDatabaseUserControllerService,
  GiftCycleControllerService,
  InfluencerControllerService,
  IntegrationControllerService,
  IntegrationTokenControllerService,
  ItOpsControllerService,
  KpiControllerService,
  LiveControllerService,
  NotificationControllerService,
  OpenControllerService,
  OrdersControllerService,
  PaymentControllerService,
  PaymentRoundControllerService,
  PersonControllerService,
  ProductControllerService,
  ResendDashboardControllerService,
  RewardControllerService,
  SecretsControllerService,
  ShippingCompanyControllerService,
  ShippingOrderControllerService,
  ShopOrderControllerService,
  SubscriberControllerService,
  SubscriptionControllerService,
  SubscriptionTypeControllerService,
  SubscriptionTypePriceControllerService,
  SubscriptionTypeTaxControllerService,
  UserControllerService,
  WebsocketControllerService
];
